(function () {
	Vue.component('nominow-input-checkbox', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				type: Boolean,
				required: false,
				default: false
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			name: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		template: `
        <div v-bind:class="{'mui-textfield' : (!nomui)}">
            <div class="control field">
                <label class="checkbox">
                    <input type="checkbox" :value="value" :checked="value" v-on:change="$emit('change', $event.target.checked)" :class="css" :name="name || label"  />
                    <span class="bin"></span>
                    {{label}}
                </label>
            </div>
        </div>
        `
	});
})();
